'use strict';

import {StructureSectionsNavigCtrl} from './structuresectionsnavigctrl.js';

export class DatasheetSectionsNavigCtrl extends StructureSectionsNavigCtrl
{
	init($scope, jsDataService){
		this.$scope = $scope;
		let strNodeList = jsDataService.get('datasheetTreeNodeList', false);
		if(false !== strNodeList){
			this.nodeList = strNodeList;
			this.navigationList = jsDataService.get('datasheetNavigationList', false);
			let idx = jsDataService.get('datasheetCurrentIndex', false);
			if(false !== idx){
				this.currentIndex = idx;
			}
		}
		else{
			this.makeStructureList(jsDataService.get('datasheetTree', {}));
			jsDataService.set('datasheetTreeNodeList', this.nodeList);
			jsDataService.set('datasheetNavigationList', this.navigationList);
			if(this.currentIndex > -1){
				jsDataService.set('datasheetCurrentIndex', this.currentIndex);
			}
		}
		this.navigationList = this.navigationList.filter(item => item.edit_url);
		this.currentIndex = this.navigationList.findIndex(obj => obj.current === true);
	}

	makeStructureList(tree){
		for(let nodeKey in tree){
			let strTree;
			if(tree[nodeKey].haschilds){
				strTree = tree[nodeKey].childs;
				delete tree[nodeKey].childs;
			}
			this.nodeList.push(tree[nodeKey]);
			if(this.isAction(tree[nodeKey])){
				this.navigationList.push(tree[nodeKey]);
			}
			if(tree[nodeKey].haschilds){
				this.makeStructureList(strTree);
			}
		}
	}
}